module.exports = "/_next/static/images/3e384fab2730465a35083f70cd23f4ea-slide-2-small.png";